module.exports = __webpack_public_path__ + "media/images/competitions/ribbon_button-b6ccdf04586163acc4b5c268c35cede9.png";